import { useController, useFormContext } from "react-hook-form";
import { Box, Typography } from "@material-ui/core";
import { Color, SelectMenu, TextFieldController } from "@bonliva-crm/ui";
import { FilterWithFavouriteProps } from "../utils/filters-record-types";
import { CollapsibleFavFilter } from "./_base/collapsible-fav-filter";
import { locale } from "@bonliva-crm/locale";

export type ZipCityFilterData = {
  zipOrCity: string | null;
  klm: string | null;
};

export type ZipCityFilterProps = FilterWithFavouriteProps;

export const ZipCityFilter = (props: ZipCityFilterProps) => {
  const { resetField, watch } = useFormContext();
  const { fieldState } = useController({ name: props.name });
  const title = props.label ?? `${locale.ZipCode}/${locale.city2}`;
  const value = watch(props.name);

  const clear = () => resetField(props.name);

  const inputs = (
    <Box display="flex" alignItems="flex-end" gridGap="8px">
      <TextFieldController
        name={`${props.name}.zipOrCity`}
        textFieldProps={{
          label: "Ort/Postnummer",
          placeholder: "123 45",
          InputLabelProps: { shrink: true },
          style: { flex: 1 }
        }}
      />

      <TextFieldController
        name={`${props.name}.klm`}
        textFieldProps={{
          label: "Avstånd i km",
          placeholder: "20",
          InputProps: {
            endAdornment: <Typography variant="body1">km</Typography>
          },
          InputLabelProps: { shrink: true },
          disabled: !value?.zipOrCity,
          style: { width: "7.5rem" }
        }}
      />
    </Box>
  );

  if (props.setFavorite) {
    return (
      <CollapsibleFavFilter
        title={title}
        favorite={props.favorite}
        onSetFavorite={props.setFavorite}
        isClearable={fieldState.isDirty}
        onClear={clear}
        isDirty={fieldState.isDirty}
        initialExpanded={fieldState.isDirty}
      >
        <Box mr={2}>{inputs}</Box>
      </CollapsibleFavFilter>
    );
  }

  return (
    <SelectMenu
      badgeLabel={value?.zipOrCity ? value?.zipOrCity : undefined}
      placeholder={
        <Typography variant="body1" style={{ color: Color.DetailsInput }}>
          {title}
        </Typography>
      }
      openByDefault={false}
      showPlaceholderOnExpand
      isClearable={fieldState.isDirty}
      onClear={() => resetField(props.name)}
      content={inputs}
    />
  );
};
